import { render, staticRenderFns } from "./OrderListPage.vue?vue&type=template&id=0990f1b7&"
import script from "./OrderListPage.vue?vue&type=script&lang=ts&"
export * from "./OrderListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports